import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaFileUpload, FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import ModalCorretoresCsv from "./ModalCorretoresCsv";



const CorretoresVinculados = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_corretores, setLoadingcorretores] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [corretores, setcorretores] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [corretores_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getcorretores = async (page, search) => {

    let response = await Request.Get(`faculdade/get_corretores_vinculados/${processo_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setcorretores(response.corretores);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingcorretores(false);


    }
  };




  const GetRelatórioCorretor = async (user) => {

    let response = await Request.Get(`faculdade/get_correcoes_corretor/${processo_id}/${user.id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    document.getElementById('download_link').href = response['link'];
    document.getElementById('download_link').click();
    // var csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(response.csv);

    // saveAs(csvContent,'correcoes_corretor_'+user.name+'.csv');

  };

  const DeleteRedacao = async (corretores_id) => {

    let response = await Request.Delete(`faculdade/desvincular_corretor/${corretores_id}/${processo_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getcorretores(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getcorretores(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <>

            <a id="download_link" target="_blank"></a>


            {/* <hr /> */}
            {loading_screen == false && <div className="module-card-container">

                <ModalCorretoresCsv
          onFinish={() => {
            setLoadingcorretores(true);
            Getcorretores(1, search_oficial);
          }}
          showModal={showModal}
          setShowModal={(e) => setShowModal(e)}
          processo_id={processo_id}
          processo_name={processo_name} />


                <div className="module-breadcrumb">

                    <button
            className="breadcrumb-back"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{t("dashboard")}


          </button>

                    <span>/</span>

                    <strong>{t("graders")}</strong>

                </div>

                <div className="module-title-row">

                    <div>

                        <h3 style={{ fontWeight: 'bold' }}>{`
                            ${t("graders")}
                        `}</h3>

                        <p>{`
                            ${t("legacy_gerencie_os_corretores_vinculados_ao_processo")}
                        `}</p>

                    </div>

                    <button
            className="btn-dashboard-modern"
            onClick={() =>
            props.setState({
              activeTab: -1
            })
            }>{`
                        ${t("legacy_dashboard")}
                    `}
          </button>

                </div>
                {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                {/* <br /> */}

                <div className="module-toolbar">

                    <Search
            placeholder={t("legacy_pesquisar_pelo_nome_do_corretor")}
            ValueChange={(value) => {

              clearTimeout(pesquisarTimeout);

              pesquisarTimeout = setTimeout(() => {

                let page = { ...pagination };

                page.current_page = 1;

                setPagination(page);

                setSearchOficial(value);

                setLoadingcorretores(true);

                Getcorretores(1, value);

              }, 500);

            }} />


                    <div className="module-actions">

                        <Link
              to={`/corretores_vinculados/register/${processo_id}`}
              className="btn-module-primary">


                            <FaListAlt />

                            {t("action_add_graders")}

                        </Link>

                        <button
              onClick={() => {
                setShowModal(true);
              }}
              className="btn-module-secondary">


                            <FaFileUpload />

                            {t("action_import_csv")}

                        </button>

                    </div>

                </div>

                <div className="table-modern-card">
                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>{t("label_name")}</th>
                                <th>{t("label_email")}</th>
                                <th>{t("rooms")}</th>
                                <th>{t("ui_correcoes_redacoes_440ee433")}</th>

                                <th>{t("legacy_alunos")}</th>
                                <th>{t("ui_correcoes_dissertativas_926a5325")}</th>


                                <th data-priority="3">{t("label_actions")}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading_corretores == false && corretores.map((item, id) =>

              <tr key={id}>
                                    <td>

                                        <div className="redacao-name">

                                            <strong>
                                                {item.name}
                                            </strong>

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.email}

                                        </div>

                                    </td>
                                    <td>

                                        <div className="salas-list">

                                            {
                    item.salas.length ?
                    item.salas.map((sala, index) =>

                    <div
                      key={index}
                      className="badge badge-light">{`

                                                            ${t("legacy_sala")} `}
                      {sala.sala.numero}

                                                        </div>

                    ) :
                    '-'
                    }

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.count} / {item.total}

                                        </div>

                                    </td>

                                    <td>

                                        <div className="redacao-preview">

                                            {item.numero_alunos}

                                        </div>

                                    </td>
                                    <td>

                                        <div className="redacao-preview">

                                            {item.respostas_alunos_corrigidas}
                                            /
                                            {item.respostas_alunos}

                                        </div>

                                    </td>


                                    {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                    <td>

                                        <div className="actions-group">

                                            <button
                      className="action-btn info"
                      onClick={() => {

                        GetRelatórioCorretor(item);

                      }}>

                                                <MdFileDownload />
                                            </button>

                                            <button
                      className="action-btn danger"
                      onClick={() => {

                        setRedacaoId(item.id);

                        setShowWarning(true);

                      }}>

                                                <MdDelete />
                                            </button>

                                        </div>

                                    </td>

                                </tr>
              )}

                        </tbody>
                    </table>
                    {loading_corretores == true &&
          <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                            {/* <div className="spinner-border text-primary" role="status"  >
                </div> */}
                            <CircularProgress />
                        </div></div>

          }
                </div>
                {loading_corretores == false && corretores.length == 0 && <div className="empty-module">

                    <div className="empty-module-icon">
                        👨‍🏫
                    </div>

                    <h3>{`
                        ${t("empty_no_grader_found")}
                    `}</h3>

                    <p>
                        Vincule o primeiro corretor ao processo.
                    </p>

                </div>}

                <Pagination
          className={pagination.last_page == 1 ? "hide" : ""}
          style={{ display: "flex", justifyContent: "flex-end" }}
          count={pagination.last_page}
          value={pagination.current_page}
          onChange={(_, value) => {
            setLoadingcorretores(true);
            console.log(_, value);
            let page = { ...pagination };
            page.current_page = value;
            setPagination(pagination);
            Getcorretores(value, search_oficial);
          }} />


                {/* {this.state.andamento == true && <AvaliacaoAndamento get_corretores={this.get_corretores.bind(this)} {...this.props} />} */}

            </div>}

            {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                {/* <div className="spinner-border text-primary" role="status"  >
            </div> */}
                <CircularProgress />
            </div></div>}

            <SweetAlert
        warning
        title={t("legacy_atencao")}
        onConfirm={() => {
          setShowWarning(false);
          setLoadingcorretores(true);
          DeleteRedacao(corretores_id);
          // this.delete_banner(this.state.banner_to_delete);
        }}
        onCancel={() => {
          setShowWarning(false);
        }}
        show={show_warning}
        confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
        cancelBtnText={t("legacy_cancelar")}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        showCancel={true}>{t("ui_ao_desvincular_este_corretor_ele_nao_tera_mais_ace_2636a0a7")}


      </SweetAlert>


        </>);

};

export default CorretoresVinculados;
